import cloneDeep from "lodash/cloneDeep";
import clone from "lodash/clone";
import uuid from "uuid";

import EventManager from "../../../store/sqftEventManager";
import {pnpolyArray} from "../../../../../lib/pnpoly";
import resizeLine, {getMaxResizeWidth} from "./resizeLine";
import config from "../../../store/sqftConfig";
import {
  getPointDistance,
  orientation,
  measureDistanceToInches,
  distanceToMillimeters,
  distanceToInches,
  getFontsize,
  get45CornerLegDistanceByHypotenuse,
  getAngleBetweenTwoPoints,
  getParallelPoints,
  getPointField,
  rotatePoint,
  mmToInches,
} from "../../../../../helpers/sqftHelper";
import COLOR_THEMES, {COLOR} from "../../../store/colorThemes";
import store from "../../../../../../../store";
import {updateSQFTCalculations} from "../../../../../../../actions/sqftFunctions";
import sqftConfig from "../../../store/sqftConfig";
import Config from "../../../../../../../config";
import RenderFigures from "../../../helpers/renderFigures";
import {updateMiteredLength, updateShapeWaterfallLength, updateUnderlaymentLength} from "../../../helpers/lineHelper";
import workspace from "../../workspace";
import {createAdjustableInput} from "../../../../../helpers/uiHelper";
import {MEASURE_UNITS} from "../../../../../constants";

export default function() {
  var self = this,
    state = {
      isHovered: false,
      isEditInputDisplayed: false,
      hoveredColor: "#FF9844",
      textWidth: 0,
      withBumpout: false,
      midPoint: {
        x: 0,
        y: 0,
        xOffset: 0,
        yOffset: 0
      },
      originalLineText: '',
      lineTextResized: '',
      lineText: '',
    },
    line = null,
    lineType = 'edge',  // by default
    lineTextColor = COLOR_THEMES[config.activeTheme].primary;
  this.id = uuid();
  this.isInited = false;
  this.design = {
    offsetFromLineEnd: 15
  }

  function setLine(value) { line = value; }
  this.getLine = () => { return line; }
  function getMidPoint(from, to) {
    return {
      x: from.x + (to.x - from.x)/2,
      y: from.y + (to.y - from.y)/2
    };
  }

  const isMouseOverText = (mousePos) => {
    const lineDirection = line.getLineDirection();
    const pointsArray = this.getHoveredArea();

    return {isHovered: pnpolyArray(pointsArray, mousePos), orientation: lineDirection.orientation};
  }

  this.getHoveredArea = () => {
    const lineDirection = line.getLineDirection();
    let pointsArray = [];
    //console.log("lineDirection.orientation", lineDirection.orientation);
    switch (lineDirection.orientation) {
      case "vertical":
        if (lineDirection.newDirection === "south") {
          pointsArray = [
            [state.midPoint.x + 40, state.midPoint.y - state.textWidth / 2 - 10],
            [state.midPoint.x + 15, state.midPoint.y - state.textWidth / 2 - 10],
            [state.midPoint.x + 15, state.midPoint.y + state.textWidth / 2 - 5],
            [state.midPoint.x + 40, state.midPoint.y + state.textWidth / 2 - 5],
          ];
        } else if (lineDirection.newDirection === "north") {
          pointsArray = [
            [state.midPoint.x - 40, state.midPoint.y - state.textWidth / 2 - 10],
            [state.midPoint.x - 15, state.midPoint.y - state.textWidth / 2 - 10],
            [state.midPoint.x - 15, state.midPoint.y + state.textWidth / 2 - 5],
            [state.midPoint.x - 40, state.midPoint.y + state.textWidth / 2 - 5],
          ];
        }
        break;
      case "horizontal": {
        pointsArray = [
          [state.midPoint.x - state.textWidth / 2 - 10, state.midPoint.y - 15],
          [state.midPoint.x + state.textWidth / 2 + 10, state.midPoint.y - 15],
          [state.midPoint.x + state.textWidth / 2 + 10, state.midPoint.y + 10],
          [state.midPoint.x - state.textWidth / 2 - 10, state.midPoint.y + 10],
        ]
        break;
      }
      case "northeast":
      case "northwest":
      case "southeast":
      case "southwest":
      default: {
        let angle = getAngleBetweenTwoPoints(line.from, line.to);
        let pointToRotate1 = {x: state.midPoint.x - state.textWidth / 2 - 10, y: state.midPoint.y - 15};
        let rotatedPoint1 = rotatePoint(pointToRotate1, state.midPoint, angle);
        let pointToRotate2 = {x: state.midPoint.x + state.textWidth / 2 + 10, y: state.midPoint.y - 15};
        let rotatedPoint2 = rotatePoint(pointToRotate2, state.midPoint, angle);
        let pointToRotate3 = {x: state.midPoint.x + state.textWidth / 2 + 10, y: state.midPoint.y + 10};
        let rotatedPoint3 = rotatePoint(pointToRotate3, state.midPoint, angle);
        let pointToRotate4 = {x: state.midPoint.x - state.textWidth / 2 - 10, y: state.midPoint.y + 10};
        let rotatedPoint4 = rotatePoint(pointToRotate4, state.midPoint, angle);
        pointsArray = [
          [rotatedPoint1.x, rotatedPoint1.y],
          [rotatedPoint2.x, rotatedPoint2.y],
          [rotatedPoint3.x, rotatedPoint3.y],
          [rotatedPoint4.x, rotatedPoint4.y],
          // [state.midPoint.x - state.textWidth / 2 - 10, state.midPoint.y - 15],
          // [state.midPoint.x + state.textWidth / 2 + 10, state.midPoint.y - 15],
          // [state.midPoint.x + state.textWidth / 2 + 10, state.midPoint.y + 10],
          // [state.midPoint.x - state.textWidth / 2 - 10, state.midPoint.y + 10],
        ]
        break
      }
    }
    return pointsArray
  }

  function onMouseMove(mousePos, e) {
    void e;
    const {isHovered, orientation} = isMouseOverText(mousePos);
    state.isHovered = isHovered;
    if (state.isHovered) {
      EventManager.stealCursor();
      EventManager.setCursor((orientation === "horizontal") ? "text" : "text-vertical", self);
    } else {
      EventManager.resetCursor(self);
    }
  }

  const onMouseDown = () => {
    if (state.isHovered && !document.querySelector(".line-input")) {
      window.lineInputFocused = true;
      EventManager.stealCursor();
      state.isEditInputDisplayed = true;

      const maxLength = Math.round(getMaxResizeWidth(line) * config.getMeasureMultiplier());
      let initialValue;
      if (sqftConfig.measureUnit === MEASURE_UNITS.Imperial) {
        initialValue = Math.round10(self.getLineDistanceFull() * config.getMeasureMultiplier(), -6);
        initialValue = distanceToInches(initialValue).replace("\"", "");
      } else if (sqftConfig.measureUnit === MEASURE_UNITS.Metric) {
        initialValue = Math.round10(self.getLineDistanceFull() * config.getMeasureMultiplier());
      }
      //console.log("initialValue", initialValue);
      //const pointDistance = Math.sqrt(Math.pow(line.to.x - line.from.x, 2) + Math.pow(line.to.y - line.from.y, 2));
      //console.log("pointDistance", pointDistance);


      const pos = { x: state.midPoint.x, y: state.midPoint.y };

      const inputWrapper = createAdjustableInput({
        position: pos,
        initialValue: initialValue.toString(),
        min: 1,
        max: maxLength,
        orientation: "horizontal",
        onChange: (value) => {
          if (sqftConfig.measureUnit === MEASURE_UNITS.Metric) {
            value = mmToInches(value);
          }
          setNewLineWidth(value - self.getAdditionalLineDistance())
        }, // Update line width on change
        onClose: () => {
          window.lineInputFocused = false;
          state.isEditInputDisplayed = false;
        },
        step: 1,
      });

      document.querySelector(".sqft-main-grid").appendChild(inputWrapper);

      // Focus and select input on creation
      const input = inputWrapper.querySelector(".line-input-field");
      input.focus();
    }
  };

  function setNewLineWidth(lineWidth) {
    const distance = getPointDistance(line.from, line.to);
    const diff = lineWidth - distance;
    const roundedDiff = Math.round10(diff, -4)
    //console.log("setNewLineWidth roundedDiff", roundedDiff);
    const reduxState = store.getState();
    const isWallsLockMode = reduxState.sqftMenuState.isWallsLockMode;
    resizeLine(line, roundedDiff, isWallsLockMode);
    updateShapeWaterfallLength(line);
    updateMiteredLength(line);
    updateUnderlaymentLength(line);

    const state = store.getState();
    const updateCalculations = state.sqftState.updateCalculations;
    store.dispatch(updateSQFTCalculations(updateCalculations + 1));
  }
  function getCtxColor(ctx, lineType) {
    return (lineType === "wall")
      ? state.isHovered ? state.hoveredColor : ctx.fillStyle
      : state.isHovered ? state.hoveredColor : COLOR_THEMES[config.activeTheme].primary;
  }
  this.destroy = (protect) => {
    if (!protect) {
      EventManager.removeEvent(self);
      this.isInited = false
    }
  };
  this.import = (data) => {
    state = data.state;
    this.id = data.id
  };
  this.export = () => {
    return { id: this.id, state: cloneDeep(state) }
  };
  this.init = function(line) {
    setLine(line);
    this.initEvents();
  };
  this.initEvents = () => {
    this.isInited = true;
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      onMouseMove,
      this,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      onMouseDown,
      this,
      EventManager.priorities.SEGMENT
    );
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render,
      this,
      EventManager.priorities.OVERLAY
    );
  };
  this.deregisterEvents = () => {
    EventManager.removeEvent(this);
    this.isInited = false;
  };
  this.reInitEvents = () => {
    if (!this.isInited) {
      this.initEvents();
    }
  };
  this.removeLineText = function () {
    state.originalLineText = '';
    lineType = 'edge';  // by default
    lineTextColor = COLOR_THEMES[config.activeTheme].primary;
  };
  this.renderEdgeText = (edgeName) => {
    state.originalLineText = edgeName;
    lineType = 'edge';
    lineTextColor = COLOR_THEMES[config.activeTheme].active;
  };
  this.renderBacksplashText = (backsplashName, type) => {
    //lineText = backsplashName;
    state.originalLineText = line.getBacksplashHeight() + sqftConfig.getMeasureUnitPostfix() +" " + workspace.intl.formatMessage({id: "sqft.navigation.submenu.backsplash"});
    lineType = type;
    lineTextColor = (type === "wall") ? "#000000" : COLOR_THEMES[config.activeTheme].primary;
  };
  this.renderWaterfallText = (name, type) => {
    state.originalLineText = name;
    lineType = type;
    lineTextColor = (type === "wall") ? "#000000" : COLOR_THEMES[config.activeTheme].primary;
  };
  this.getMidpoint = function () {
    return state.midPoint;
  };
  this.setMidpointOffset = function (xOffset, yOffset) {
    state.midPoint.xOffset = xOffset;
    state.midPoint.yOffset = yOffset;
  };
  this.getLineLength = function () {
    var distance = getPointDistance(line.from, line.to);

    return measureDistanceToInches(distance);
  };
  this.getLineLengthText = function () {
    let distance = this.getLineDistanceFull();

    return config.measureUnit === "Metric" ? distanceToMillimeters(distance) : distanceToInches(distance);
  };
  this.getLineDistanceFull = function () {
    return getPointDistance(line.from, line.to) + this.getAdditionalLineDistance();
  };
  this.getLineDistanceFullInPixels = function () {
    const lineLengthInPx = getPointDistance(line.calculateRenderPosition(line.from), line.calculateRenderPosition(line.to));
    const scale = config.scale;
    let additionalLineDistance = this.getAdditionalLineDistance() * scale;
    if (additionalLineDistance < 0) {
      additionalLineDistance -= this.design.offsetFromLineEnd; // add gray line margin
    } else if (additionalLineDistance > 0) {
      additionalLineDistance += this.design.offsetFromLineEnd; // add gray line margin
    }

    return lineLengthInPx + additionalLineDistance;
  };
  this.getAdditionalLineDistance = function () {
    let additionalDistance = 0;
    const prevLine = line.getParent().getPrevLine(line);
    if (line.to.angle > 0 || line.to.arcLength > 0) {
      additionalDistance -= get45CornerLegDistanceByHypotenuse(line.to.angle || line.to.arcLength);
    }

    if (prevLine.to.angle > 0 || prevLine.to.arcLength > 0 ) {
      additionalDistance -= get45CornerLegDistanceByHypotenuse(prevLine.to.angle || prevLine.to.arcLength);
    }

    return +additionalDistance;
  };

  this.render = function(ctx) {
    if (state.isEditInputDisplayed) {
      return;
    }

    let scale = config.scale,
      fontSize = getFontsize(),
      font = (fontSize).toString() + "px " + config.activeFontBold,
      lineDirection = line.getLineDirection(),
      offset = line.getOffset(),
      distance = this.getLineDistanceFullInPixels(),
      dstring = this.getLineLengthText(),
      midPoint = getMidPoint(line.from, line.to),
      orientationValue = line.getOrientation(),
      space,
      mtext,
      medgeText,
      xOffset = 0,
      yOffset = 0,
      lineCornerWidth = 0,
      fromPosOnField = getPointField(line.from.x, line.from.y, line),
      prevLine;

    state.lineTextResized = clone(state.originalLineText);
    const parent = line.getParent();

    ctx.beginPath();
    ctx.font = font;

    mtext     = ctx.measureText(dstring);
    medgeText = ctx.measureText(state.lineTextResized);
    space     = ctx.measureText(' ');
    state.textWidth = Math.round(mtext.width * 100) / 100;

    let marginTotal = 0;

    for (let i in lineDirection.cornerMargins) {
      marginTotal += lineDirection.cornerMargins[i];
    }

    if (medgeText.width + ctx.measureText(dstring).width > distance) {
      fontSize = 14;
      ctx.font = "14px " + config.activeFontBold;
      mtext     = ctx.measureText(dstring);
      medgeText = ctx.measureText(state.lineTextResized);
      space     = ctx.measureText(' ');

      // Adjust text size based on distance
      if (distance < 20 * config.scale + marginTotal * 40) {
        state.lineTextResized  = '';
        medgeText = ctx.measureText(state.lineTextResized);
      } else {
        if (state.originalLineText && (medgeText.width + ctx.measureText(dstring).width > distance - marginTotal * 40)) {
          while (medgeText.width && (medgeText.width + ctx.measureText(dstring).width > distance - marginTotal * 40)) {
            state.lineTextResized = state.lineTextResized.slice(0, -1);
            medgeText = ctx.measureText(state.lineTextResized);
          }
        }
      }
    }

    lineCornerWidth += line.get45CornerLegDistance() / 2 * scale;
    prevLine = parent.getPrevLine(line);
    lineCornerWidth -= prevLine.get45CornerLegDistance() / 2 * scale;

    midPoint.y = midPoint.y * scale + offset.y;
    midPoint.x = midPoint.x * scale + offset.x;
    ctx.textAlign = "center";
    //midPoint.y += fontSize / 2;
    // ctx.fillStyle = "rgba(255,255,255,0)";
    // ctx.fillRect(midPoint.x - tLen/2 - 4, midPoint.y - (fontSize), tLen + 4, fontSize + 4);
    ctx.beginPath();
    ctx.fillStyle = state.isHovered
      ? state.hoveredColor
      : (lineType === "wall") ? "#000000" : COLOR_THEMES[config.activeTheme].primary;

    let marginFrom = 0,
      marginTo = 0;

    switch (lineDirection.orientation) {
      case "horizontal": {
        if (lineDirection.newDirection === "east") {
          midPoint.x -= lineCornerWidth;
          marginFrom = (lineDirection.cornerMargins.fromLeft) ? marginFrom + 9 : marginFrom;
          marginTo = (lineDirection.cornerMargins.fromRight) ? marginTo + 9 : marginTo;
        } else if (lineDirection.newDirection === "west") {
          midPoint.x += lineCornerWidth;
          marginFrom = (lineDirection.cornerMargins.fromRight) ? marginFrom + 9 : marginFrom;
          marginTo = (lineDirection.cornerMargins.fromLeft) ? marginTo + 9 : marginTo;
        }
        yOffset = (lineDirection.newDirection === "west" ? 33 : -20) + (state.midPoint.yOffset  * scale);
        if (state.lineTextResized) {
          ctx.fillStyle = lineTextColor;
          ctx.wrapText(state.lineTextResized, midPoint.x - mtext.width / 2 - marginFrom + marginTo, midPoint.y + yOffset, medgeText, fontSize);
          ctx.fillStyle = getCtxColor(ctx, lineType);
          state.midPoint.x = midPoint.x + medgeText.width / 2 + space.width - marginFrom + marginTo;
          state.midPoint.y = midPoint.y + yOffset;
        } else {
          state.midPoint.x = midPoint.x - marginFrom + marginTo;
          state.midPoint.y = midPoint.y + yOffset;
        }
        ctx.wrapText(dstring, state.midPoint.x, state.midPoint.y, mtext, fontSize);
        break;
      }
      case "vertical": {
        if (lineDirection.newDirection === "south") {
          marginFrom = (lineDirection.cornerMargins.fromTop) ? marginFrom + 9 : marginFrom;
          marginTo = (lineDirection.cornerMargins.fromBottom) ? marginTo + 9 : marginTo;
          midPoint.y -= lineCornerWidth;
        } else if (lineDirection.newDirection === "north") {
          marginTo = (lineDirection.cornerMargins.fromTop) ? marginTo + 9 : marginTo;
          marginFrom = (lineDirection.cornerMargins.fromBottom) ? marginFrom + 9 : marginFrom;
          midPoint.y += lineCornerWidth;
        }
        xOffset += state.midPoint.xOffset * scale;
        state.midPoint.x = midPoint.x + xOffset;
        state.midPoint.y = midPoint.y + yOffset
          ? lineDirection.newDirection === "south"
            ? midPoint.y + medgeText.width / 2 + space.width
            : midPoint.y - medgeText.width / 2 + space.width
          : midPoint.y;
        ctx.save();
        ctx.translate(
          lineDirection.newDirection === "south" ? midPoint.x + xOffset : midPoint.x + xOffset,
          lineDirection.newDirection === "south" ? midPoint.y - 5 : midPoint.y - 10
        );
        ctx.rotate(lineDirection.newDirection === "south" ? Math.PI / 2 : -Math.PI / 2);
        if (state.lineTextResized) {
          ctx.fillStyle = lineTextColor;
          ctx.wrapText(state.lineTextResized, 0 - mtext.width / 2 + marginFrom - marginTo, -fontSize, medgeText, fontSize);
          ctx.fillStyle = getCtxColor(ctx, lineType);
          ctx.wrapText(dstring, 0 + medgeText.width / 2 + space.width + marginFrom - marginTo, -fontSize - yOffset, mtext, fontSize);
        } else {
          ctx.wrapText(dstring, 0 + marginFrom - marginTo, -fontSize, mtext, fontSize);
        }
        break;
      }
      case "NORTHWEST":
      case "NORTHEAST":
      case "SOUTHWEST":
      case "SOUTHEAST": {
        ctx.save();
        if (state.lineTextResized) {
          dstring = state.lineTextResized + ' ' + dstring;
        }
        //this.renderFrameBorder(ctx, dstring, fontSize, midPoint, orientationValue);
        const [parallelPoint1] = getParallelPoints(fromPosOnField, midPoint, -30);
        state.midPoint.x = parallelPoint1.x;
        state.midPoint.y = parallelPoint1.y;
        this.renderText(ctx, dstring, state.midPoint, fontSize, orientationValue);
        break;
      }
      default:
        break;
    }

    ctx.restore();

    if (Config.isDevMode()) {
      this.renderHoveredArea(ctx);
    }
  };

  this.renderHoveredArea = (ctx) => {
    //console.log("state.midPoint.", state.midPoint);
    const hoveredArea = this.getHoveredArea();
    ctx.beginPath();
    ctx.moveTo(hoveredArea[0][0], hoveredArea[0][1]);
    ctx.lineTo(hoveredArea[1][0], hoveredArea[1][1]);
    ctx.lineTo(hoveredArea[2][0], hoveredArea[2][1]);
    ctx.lineTo(hoveredArea[3][0], hoveredArea[3][1]);
    ctx.lineTo(hoveredArea[0][0], hoveredArea[0][1]);
    ctx.lineWidth = 2;
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.5)';
    ctx.stroke();
    ctx.closePath();
  }

  this.getFrameBorderPosition = (ctx, pos, value, fontHeight, orientationValue) => {
    const mText = ctx.measureText(value);
    let position = {
      x: pos.x,
      y: pos.y
    };

    switch (orientationValue) {
      case orientation.HORIZONTAL: {
        break;
      }
      case orientation.VERTICAL: {
        break;
      }
      case orientation.NORTHWEST: {
        position = {
          x: pos.x - mText.width,
          y: pos.y - this.design.offsetFromLineEnd
        };
        break;
      }
      case orientation.NORTHEAST: {
        position = {
          x: pos.x - mText.width,
          y: pos.y - this.design.offsetFromLineEnd
        };
        break;
      }
      case orientation.SOUTHWEST: {

        break;
      }
      case orientation.SOUTHEAST: {

        break;
      }
      default:
        break;
    }
    return position
  }

  this.renderFrameBorder = (ctx, value, fontHeight, pos, orientationValue) => {
    ctx.beginPath();
    const mText = ctx.measureText(value);
    ctx.strokeStyle = COLOR_THEMES[sqftConfig.activeTheme].primary;
    ctx.lineWidth = 2;
    ctx.fillStyle = COLOR.white

    const angle = getAngleBetweenTwoPoints(line.from, line.to);
    let position = this.getFrameBorderPosition(ctx, pos, value, fontHeight, orientationValue);

    ctx.save();
    ctx.translate(
      position.x,
      position.y,
    );
    ctx.rotate(angle * (Math.PI / 180));
    RenderFigures.roundedRect(ctx,
      0, // absolute pos: //pos.x - mText.width / 1.25 / sqftConfig.scale * sqftConfig.defaultScale,
      0, // absolute pos: //pos.y - fontHeight,
      mText.width * 1.5 + sqftConfig.scale / sqftConfig.defaultScale,
      fontHeight + 6,
      5,
      true,
      true
    );
    ctx.restore();
    ctx.closePath();
  }

  this.renderText = (ctx, value, pos, fontHeight, orientationValue) => {
    const //scale = sqftConfig.scale,
      font = fontHeight + "px " + config.activeFontBold,
      mText = ctx.measureText(value);

    //let position = this.getTextPosition(ctx, pos, value, fontHeight, orientationValue);

    ctx.beginPath();
    ctx.font = font;
    ctx.textAlign = "center";
    ctx.fillStyle = getCtxColor(ctx, lineType);

    let angle = getAngleBetweenTwoPoints(line.from, line.to);
    //this will help to rotate upside down text
    if ([orientation.NORTHWEST, orientation.SOUTHWEST].indexOf(orientationValue) !== -1) {
      angle += 180;
    }
    ctx.save();
    //RenderFigures.renderCircle(pos, 5,1, '#284da8');
    ctx.translate(
      pos.x,
      pos.y
    );
    ctx.rotate(angle * (Math.PI / 180));
    //ctx.wrapText(value, fontHeight / 2,  mText.width / ( 2 * scale), mText, fontHeight);
    ctx.wrapText(value, 0,  0, mText, fontHeight);
    ctx.restore();
    ctx.closePath();
  }
}
